import {
  type AIModelChoices,
  getSampleVariantFromMaterial,
  PaginatedEvidenceList,
  SampleType,
  useApiSamplesV1SamplesRetrieveSuspense,
} from 'api';
import { SampleBreakdown, useSiteMaterial } from 'features';
import { useBreakpoint } from 'ui';

export const SampleDetail = ({
  sampleId,
  evidence,
  onSuccessfulEvidenceSync,
}: {
  sampleId: number;
  evidence: PaginatedEvidenceList;
  onSuccessfulEvidenceSync?: () => void;
}) => {
  const { isMobile } = useBreakpoint();
  const { data: siteMaterial } = useSiteMaterial();
  const { data: sample } = useApiSamplesV1SamplesRetrieveSuspense(sampleId);
  const aiModel = siteMaterial.material_spec.ai_model;

  return (
    <SampleBreakdown
      isMobile={isMobile}
      displayManualBreakdown={sample.type !== SampleType.AG}
      sample={sample}
      model={aiModel as AIModelChoices}
      evidence={evidence}
      variant={getSampleVariantFromMaterial(siteMaterial.material_spec.title) || 'alu'}
      mode="sample"
      onSuccessfulEvidenceSync={onSuccessfulEvidenceSync}
    />
  );
};
